import {
    AccountCircle as AccountCircleIcon,
    ExitToApp as ExitToAppIcon,
} from '@mui/icons-material';
import { useKeycloak } from '@react-keycloak/web';
import { MenuLink } from 'cleveron-web-components';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { closeMenu as closeMenuAction, openMenu as openMenuAction } from '../../actions/menu';

function AccountMenu({ closeMenu, id }) {
    const { keycloak } = useKeycloak();
    const { logout, tokenParsed } = keycloak;
    return (
        <>
            <MenuLink
                Icon={AccountCircleIcon}
                closeMenu={() => closeMenu('account')}
                id={`${id}UserButton`}
                primaryText={tokenParsed && (tokenParsed.name ? tokenParsed.name : tokenParsed.upn)}
                secondaryText={tokenParsed && tokenParsed.email}
                to="/"
            />
            <MenuLink
                Icon={ExitToAppIcon}
                closeMenu={() => {
                    logout();
                    closeMenu('account');
                }}
                id={`${id}LogoutButton`}
                primaryTextKey="page.logout"
                to="/"
            />
        </>
    );
}

const mapDispatchToProps = dispatch =>
    bindActionCreators({ closeMenu: closeMenuAction, openMenu: openMenuAction }, dispatch);

export default connect(null, mapDispatchToProps)(AccountMenu);
